import React from 'react'
import { TransactionList } from './list/page'

export const TransactionByDayPage = (): JSX.Element => {
  return <TransactionList></TransactionList>
}
